import axios, { ApiResponse, getRequestError } from "./axios";

export enum Methods {
  SetAuthData = "SetAuthData",
  GetConfig = "GetConfig",
  GetPanels = "GetPanels",
  RegisterPanel = "RegisterPanel",
  SubmitAdOrder = "SubmitAdOrder",
  GetPanelAds = "GetPanelAds",
  GetPaymentToken = "GetPaymentToken",
  InquireBonusCode = "InquireBonusCode",
  GetAdReport = "GetAdReport",
  GetMemberCount = "GetMemberCount",
  GetAdPrice = "GetAdPrice",
  CalculatePrice = "CalculatePrice",
  GetPeriodCapacityData = "GetPeriodCapacityData",
  InquireShahkar = "InquireShahkar",
  SubmitBusinessAdOrder = "SubmitBusinessAdOrder",
  CreateCampaign = "CreateCampaign",
  GetCredit = "GetCredit",
  GetCampaignAds = "GetCampaignAds",
  ChangeCampaignState = "ChangeCampaignState",
  GetAvailableCampaignStartDate = "GetAvailableCampaignStartDate",
  GetDefaultCampaignPackages = "GetDefaultCampaignPackages",
  GetCampaignPaymentToken = "GetCampaignPaymentToken",
  ChangeCampaignStopValue = "ChangeCampaignStopValue",
  GetUserCustomCampaignPackage = "GetUserCustomCampaignPackage",
  GetAdJoinReport = "GetJoinAdReport",
  GetWheelState = "GetWheelState",
  WheelSpin = "WheelSpin",
}

export enum Endpoints {
  SetOverallNPS = "SetOverallNPS",
  InquireNPS = "InquireNPS",
}

export const makeCall = <RequestType, ResponseType, Errors extends number>(
  method: Methods
): ((body: RequestType) => ApiResponse<ResponseType, Errors>) => {
  return (body: RequestType) =>
    axios
      .post(`/MakeCall?${method}`, body, { headers: { method: method } })
      .then((res) => ({
        response: res.data as ResponseType,
      }))
      .catch((error) => {
        return { error: getRequestError<Errors>(error) };
      });
};

export const callEndpoint = <RequestType, ResponseType, Errors extends number>(
  endpoint: Endpoints
): ((body: RequestType) => ApiResponse<ResponseType, Errors>) => {
  return (body: RequestType) =>
    axios
      .post(`/${endpoint}`, body)
      .then((res) => ({
        response: res.data as ResponseType,
      }))
      .catch((error) => {
        return { error: getRequestError<Errors>(error) };
      });
};
